<template>
	<el-row>
		<el-col :lg="4" :xl="4">
			<div class="hidden-md-and-down">&nbsp;</div>
		</el-col>
		<el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
			<div class="intro-container">
				<div class="item" v-for="item in data" :key="item.id">
					<div class="image">
						<img :src="item.src" />
					</div>
					<h4>{{item.title}}</h4>
					<p v-for="p in item.contents" :key="p">{{p}}</p>
				</div>
			</div>
		</el-col>
		<el-col :lg="4" :xl="4">
			<div class="hidden-md-and-down">&nbsp;</div>
		</el-col>
	</el-row>
</template>

<script>
	export default {
		name: 'introPCS',
		props: ['data']
	}
</script>

<style>
	@media (min-width:992px) {
		.intro-container {
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: row;
			width: 100%;
			/* background-color: #25A4BB; */
		}

		.intro-container .item {
			display: flex;
			flex-direction: column;
			align-items: center;
			margin-top: 61px;
			margin-bottom: 40px;
			width: 278px;
			height: 383px;
			border-radius: 4px;

		}

		.intro-container .item:not(:first-child) {
			margin-left: 131px;
		}
	}

	.intro-container .item .image {
		margin-top: 39px;
		margin-bottom: 35px;
		height: 120px;
		width: 120px;
	}

	.intro-container .item h4 {
		font-size: 20px;
		font-family: "microsoft yahei";
		color: #000000;
		line-height: 24px;
		margin-bottom: 18px;
	}

	.intro-container .item p {
		display: block;
		width: 100%;
		font-size: 14px;
		font-family: "microsoft yahei";
		color: rgba(87, 90, 102, 1);
		line-height: 24px;
		text-align: center;
		margin: 0;
	}

	.intro-container .item:hover {
		box-shadow: 7px 0px 29px rgba(76, 132, 255, 0.09);
	}


	@media (max-width:992px) {
		.intro-container {
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			width: 100%;
		}

		.intro-container .item {
			display: inline-flex;
			flex-direction: column;
			align-items: center;
			/* margin-top: 61px; */
			/* margin-bottom: 40px; */
			width: 278px;
			height: 383px;
			border-radius: 4px;
		}
		.intro-container .item h4 {
			font-size: 18px;
			font-family: "microsoft yahei";
			color: #000000;
			line-height: 24px;
			margin-bottom: 18px;
		}
		
	}




	#introPCS {
		width: 100%;
		height: 484px;
		background-color: #FFF;
	}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/IntroPCS.vue